export const REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.REQUIRED_ERROR_MSG';
export const START_DATE_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.START_DATE_REQUIRED_ERROR_MSG';
export const END_DATE_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.END_DATE_REQUIRED_ERROR_MSG';
export const DATE_LESS_THAN_OR_EQUAL_TO_TODAY_ERROR_MSG =
  'Library.FormValidErrorMsg.DATE_LESS_THAN_OR_EQUAL_TO_TODAY_ERROR_MSG';
export const DATE_LESS_THAN_TODAY_ERROR_MSG =
  'Library.FormValidErrorMsg.DATE_LESS_THAN_TODAY_ERROR_MSG';
export const END_DATE_GREATER_OR_EQUAL_TO_START_DATE_ERROR_MSG =
  'Library.FormValidErrorMsg.END_DATE_GREATER_OR_EQUAL_TO_START_DATE_ERROR_MSG';
export const INVALID_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVALID_FORMAT_ERROR_MSG';
export const START_DATE_INVALID_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.START_DATE_INVALID_FORMAT_ERROR_MSG';
export const END_DATE_INVALID_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.END_DATE_INVALID_FORMAT_ERROR_MSG';
export const INVALID_MOBILE_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVALID_MOBILE_FORMAT_ERROR_MSG';
export const INVALID_PHONE_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVALID_PHONE_FORMAT_ERROR_MSG';
export const EXIT_HINT_WITHOUT_SAVING_MSG =
  'Library.FormValidErrorMsg.EXIT_HINT_WITHOUT_SAVING_MSG';
export const EXIT_HINT_WITHOUT_DOWNLOAD_MSG =
  'Library.FormValidErrorMsg.EXIT_HINT_WITHOUT_DOWNLOAD_MSG';
export const NOT_CORRECT_MSG = 'Library.FormValidErrorMsg.NOT_CORRECT_MSG';
export const EXIST_MSG = 'Library.FormValidErrorMsg.EXIST_MSG';
export const ADDRESS_LEVEL_1_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_LEVEL_1_REQUIRED_ERROR_MSG';
export const ADDRESS_LEVEL_2_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_LEVEL_2_REQUIRED_ERROR_MSG';
export const ADDRESS_LEVEL_3_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_LEVEL_3_REQUIRED_ERROR_MSG';
export const ADDRESS_LEVEL_4_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_LEVEL_4_REQUIRED_ERROR_MSG';
export const ADDRESS_LEVEL_5_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_LEVEL_5_REQUIRED_ERROR_MSG';
export const ADDRESS_POSTCODE_REQUIRED_ERROR_MSG =
  'Library.FormValidErrorMsg.ADDRESS_POSTCODE_REQUIRED_ERROR_MSG';
export const MAX_LENGTH_HINT = 'Library.FormValidErrorMsg.MAX_LENGTH_HINT';
export const MAX_LENGTH = 'Library.FormValidErrorMsg.MAX_LENGTH';
export const INVAILD_TIN_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVAILD_TIN_FORMAT_ERROR_MSG';
export const MIN_LENGTH = 'Library.FormValidErrorMsg.MIN_LENGTH';
export const ENTER_AT_LEAST_TWO_CHARACTERS =
  'Library.FormValidErrorMsg.ENTER_AT_LEAST_TWO_CHARACTERS';
export const INVALID_ID_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVALID_ID_FORMAT_ERROR_MSG';
export const INVALID_DEALER_CODE_FORMAT_ERROR_MSG =
  'Library.FormValidErrorMsg.INVALID_DEALER_CODE_FORMAT_ERROR_MSG';
export const INVALID_EMAIL = 'Library.FormValidErrorMsg.INVALID_EMAIL';
export const EXCEED_MAXIMUM_DATE_RANGE =
  'Library.FormValidErrorMsg.EXCEED_MAXIMUM_DATE_RANGE';
export const DATE_GREATER_THEN_SYSDATE =
  'Library.FormValidErrorMsg.DATE_GREATER_THEN_SYSDATE';
export const DATE_LESS_THEN_SYSDATE =
  'Library.FormValidErrorMsg.DATE_LESS_THEN_SYSDATE';
export const DATE_REQUIRED = 'Library.FormValidErrorMsg.DATE_REQUIRED';
export const DATE_RANGE_INVALID =
  'Library.FormValidErrorMsg.EXCEED_MAXIMUM_DATE_RANGE_HINT';
export const DATE_START_COMP = 'Library.FormValidErrorMsg.DATE_START_COMP';
export const DATE_END_COMP = 'Library.FormValidErrorMsg.DATE_END_COMP';
export const PATTERN_ERROR_MSG = 'Library.FormValidErrorMsg.PATTERN_ERROR_MSG';
export const FORM_VALIDATION_ERROR_MSG_MAP = {
  required: REQUIRED_ERROR_MSG,
  idNotAllow: INVALID_ID_FORMAT_ERROR_MSG,
  dealerCodeNotAllow: INVALID_DEALER_CODE_FORMAT_ERROR_MSG,
  startRequired: START_DATE_REQUIRED_ERROR_MSG,
  endRequired: END_DATE_REQUIRED_ERROR_MSG,
  invalidDate: INVALID_FORMAT_ERROR_MSG,
  invalidPhone: INVALID_PHONE_FORMAT_ERROR_MSG,
  invalidMobile: INVALID_MOBILE_FORMAT_ERROR_MSG,
  startInvalidDate: START_DATE_INVALID_FORMAT_ERROR_MSG,
  endInvalidDate: END_DATE_INVALID_FORMAT_ERROR_MSG,
  rangeInvalid: END_DATE_GREATER_OR_EQUAL_TO_START_DATE_ERROR_MSG,
  exceedMaxDateRange: EXCEED_MAXIMUM_DATE_RANGE,
  dateGreaterThenSysdate: DATE_GREATER_THEN_SYSDATE,
  startDateGreaterThenSysdate: DATE_GREATER_THEN_SYSDATE,
  endDateGreaterThenSysdate: DATE_GREATER_THEN_SYSDATE,
  dateLessThenSysdate: DATE_LESS_THEN_SYSDATE,
  dateRequired: DATE_REQUIRED,
  addressLevel1Requied: ADDRESS_LEVEL_1_REQUIRED_ERROR_MSG,
  addressLevel2Requied: ADDRESS_LEVEL_2_REQUIRED_ERROR_MSG,
  addressLevel3Requied: ADDRESS_LEVEL_3_REQUIRED_ERROR_MSG,
  addressLevel4Requied: ADDRESS_LEVEL_4_REQUIRED_ERROR_MSG,
  addressLevel5Requied: ADDRESS_LEVEL_5_REQUIRED_ERROR_MSG,
  addressPostcodeRequied: ADDRESS_POSTCODE_REQUIRED_ERROR_MSG,
  addressLevel5ExceededMaxLength: MAX_LENGTH_HINT,
  maxlength: MAX_LENGTH,
  minlength: MIN_LENGTH,
  enterAtLeastTwoCharacters: ENTER_AT_LEAST_TWO_CHARACTERS,
  email: INVALID_EMAIL,
  minDateComp: DATE_END_COMP,
  maxDateComp: DATE_START_COMP,
  pattern: PATTERN_ERROR_MSG,
  invaildTinFormat: INVAILD_TIN_FORMAT_ERROR_MSG,
};
// agreement signed date
export const DATE_GREATER_THAN_OR_EQUAL_TO = 'must be greater than or equal to';
